import { useFormationsData } from './useFormationsData.js'
import { useFormationComputed } from './useFormationComputed.js'
import { useFormationSessions } from './useFormationSessions.js'
import { useFormationHandlers } from './useFormationHandlers.js'
import { formatSessionDate } from '../../utils/formationUtils.js'
import { parseDate } from '../../utils/dateUtils.js'

export function useFormations() {
  const {
    loadingFormations,
    formationsData,
    sessionsData,
    formationMessages,
    categoriesList,
    loadFormationsData
  } = useFormationsData()

  const createFormationComputed = (getFormValue) => {
    const baseComputed = useFormationComputed(
      getFormValue,
      formationsData,
      formationMessages,
      parseDate,
      categoriesList
    )
    
    const sessionsComputed = useFormationSessions(
      getFormValue, 
      sessionsData, 
      parseDate
    )

    return {
      ...baseComputed,
      ...sessionsComputed
    }
  }

  const createFormationHandlers = (form, getFormValue, getFormationMessage, getSelectedFormation) => {
    return useFormationHandlers(form, getFormValue, getFormationMessage, getSelectedFormation)
  }

  return {
    categoriesList,
    loadingFormations,
    formationsData,
    sessionsData,
    loadFormationsData,
    parseDate,
    formatSessionDate,
    createFormationComputed,
    createFormationHandlers
  }
}

// Ré-exporter les utilitaires pour compatibilité
export { formatFormationName, requiresExteriorSpace, isARIFormation, isCamionUniteMobileFormation, formatSessionDate } from '../../utils/formationUtils.js'

